export const environment: any = {
  production: true,
  apiUrl: 'https://srpzuid-cfg-wapi-demo.azurewebsites.net/api/v1',
  swaggerUrl: 'https://srpzuid-cfg-wapi-demo.azurewebsites.net/index.html',
  angularAppUrl: 'https://srpzuidcfgappdemo.z6.web.core.windows.net',
  title: 'SRP Zuid Configurator (Demo)',
  defaultLanguage: 'nl',
  enableInputsSection: false,
  enableComponentsModeSelection: false,
  currencySymbol: '€',
  enableDemoMode: true
};
